import { createSlice } from "@reduxjs/toolkit";
import { insuranceAction } from "../actions/insuranceAction";

const initialState = {
  showInsuranceModal: false,
  showDeleteConfirmationModal: false,
  isUpdateOperation: false,
  isProcessing: false,
  selectedInsurance: null,
};

const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: insuranceAction,
});

export const {
  setShowInsuranceModal,
  setIsProcessing,
  setIsUpdateOperation,
  setSelectedInsurance,
  setShowDeleteConfirmationModal,
} = insuranceSlice.actions;
export default insuranceSlice.reducer;
